module.exports = __webpack_public_path__ + "img/list_style_numbered.764079c3.png";